export const protectedRoutes = {
  "/itinerary/new": "itineraries:create",
  "/itinerary/:id/edit": "itineraries:edit",
  "/supplier/new": "suppliers:create",
  "/supplier/:id/details": "suppliers:edit",
  "/client/new": "clients:create",
  "/client/:id/details": "clients:edit",
  "/sales-invoices": "finances:sales_invoices",
  "/receipts": "finances:receipts",
  "/purchase-invoices": "finances:purchase_invoices",
  "/purchase-invoice-payments": "finances:pi_payments",
  "/admin/agents": "agents:agent_and_groups",
  "/admin/agent-groups": "agents:agent_and_groups",
  "/admin/agent-types": "agents:agent_and_groups",
  "/admin/all-destinations":
    "administration_panel:destinations_and_pickup_points",
  "/admin/treeview-destinations":
    "administration_panel:destinations_and_pickup_points",
  "/admin/pickups": "administration_panel:destinations_and_pickup_points",
  "/admin/currencies": "administration_panel:currencies_and_taxes",
  "/admin/exchange-rates": "administration_panel:currencies_and_taxes",
  "/admin/taxes": "administration_panel:currencies_and_taxes",
  "/admin/payment-types": "administration_panel:currencies_and_taxes",
  "/admin/rooms": "administration_panel:service_types",
  "/admin/activity-types": "administration_panel:service_types",
  "/admin/transport-types": "administration_panel:service_types",
  "/admin/travel-types": "administration_panel:service_types",
  "/admin/other-types": "administration_panel:service_types",
  "/admin/extra-types": "administration_panel:service_types",
  "/admin/package-types": "administration_panel:service_types",
  "/admin/accommodation-types": "administration_panel:service_types",
  "/admin/nominal-codes": "administration_panel:service_types",
  "/admin/charges-types": "administration_panel:service_types",
  "/admin/mandatory-charges": "administration_panel:service_types",
  "/admin/star-rating": "administration_panel:service_types",
  "/admin/rate-types": "administration_panel:departments_and_rate_types",
  "/admin/departments": "administration_panel:departments_and_rate_types",
  "/admin/internal-statuses": "administration_panel:departments_and_rate_types",
  "/admin/head-offices": "administration_panel:departments_and_rate_types",
  "/supplier": "suppliers:visible",
  "/suppliers": "suppliers:visible",
  "/itinerary": "itineraries:visible",
  "/itineraries": "itineraries:visible",
  "/client": "clients:visible",
  "/clients": "clients:visible",
  "/reports": "reports:visible",
  "/admin": "administration_panel:visible",
  "/agent": "agents:agent_and_groups",
  "/flights-management": "plugins:flights_management",
  //https://tracker.globetrack.ie/issues/11374
  "/admin/third-party-api-logs": "administration_panel:api_logs",
};



// WEBPACK FOOTER //
// ./src/router/protected-routes.js